export function addCurrent(alert) {
    return {
        type: 'ADD_CURRENT',
        alert,
    }
}
